import axios from 'axios';
import jsonp from 'jsonp';
import $ from 'jquery';

const Newsletter = {
    content: null,
    init: () => {
        Newsletter.content = document.querySelector("#newsletter");
        Newsletter.contentOverlay = document.querySelector("#newsletter-overlay");
        Newsletter.triggers = document.querySelectorAll(".newsletter-trigger");
        Newsletter.requestSubmit = document.querySelector("#newsletter-submit");
        Newsletter.requestError2 = document.querySelector("#newsletter-error-2");
        Newsletter.requestError = document.querySelector("#newsletter-error");
        Newsletter.requestDone = document.querySelector("#newsletter-done");
        Newsletter.bind();
    },
    bind: (e) => {
        if (Newsletter.content) {
            [...Newsletter.triggers].forEach(newsletter => {
                newsletter.addEventListener("click", Newsletter.open, true);
            });

            Newsletter.requestSubmit.addEventListener("click", (e) => {
                if (e) e.preventDefault();
                Newsletter.send();
            });

            Newsletter.contentOverlay.addEventListener("click", (e) => {
                Newsletter.close();
            });
        }
    },
    open: (e) => {
        Newsletter.contentOverlay.classList.add("active");
        setTimeout(function() {
            Newsletter.content.classList.add("active");
        }, 1000)
    },

    close: (e) => {
        Newsletter.content.classList.remove("active");
        Newsletter.contentOverlay.classList.remove("active");

    },

    send: (e) => {

        let error = false;
        let send = false;
        let firstName = document.querySelector("#txt-first-name-2").value;
        let lastName = document.querySelector("#txt-last-name-2").value;
        let email = document.querySelector("#txt-email-2").value;

        console.log(firstName + " -- " + lastName + " .... " + email);
        let form = document.querySelector('form');
        let data = new FormData(form);

        if (firstName.length == 0 && firstName.length < 2) {
            error = true;
        }

        if (lastName.length == 0 && lastName.length < 2) {
            error = true;
        }

        if (email.length == 0 || !Newsletter.validateEmail(email)) {
            error = true;
        }


        if (error) {
            Newsletter.requestError.style.display = "block";
        } else {
            if (send == false) {
                let mailchimpform = $('#mc-embedded-subscribe-form')
                $.ajax({
                    url: mailchimpform.attr('action'),
                    type: 'POST',
                    data: mailchimpform.serialize(),
                    success: function(data) {
                        Newsletter.requestError.style.display = "none";
                        Newsletter.requestError2.style.display = "none";
                        Newsletter.requestDone.style.display = "block";
                        Newsletter.requestSubmit.disabled = true;
                        send = true;

                        setTimeout(function() {
                            Newsletter.close();
                        }, 3500)
                    }
                });
                return false;

                // $.ajax({
                //     type:'POST',
                //     url: $form.attr('action'),
                //     data: $form.serialize(),
                //     cache: false,
                //     dataType: 'json',
                //     contentType: "application/json; charset=utf-8",
                //     error: function(err) {
                //         console.log(err);
                //     },
                //     success: function(data) {
                //         if (data.result === 'success') {
                //             Newsletter.requestError.style.display = "none";
                //             Newsletter.requestError2.style.display = "none";
                //             Newsletter.requestDone.style.display = "block";
                //             Newsletter.requestSubmit.disabled = true;
                //             send = true;

                //             setTimeout(function() {
                //                 Newsletter.close();
                //             }, 3500)

                //         } else {
                //             Newsletter.requestError2.style.display = "block";
                //         }
                //     }
                // })
            }

        }
    },
    validateEmail: (email) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return (true)
        }
        return (false)
    }

}
export default Newsletter;